/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ipam';
const componentName = 'custom-usable-subnets-grid';
const prefix = `${moduleName}.${componentName}`;

export const usableSubnetsGridHeader = `${prefix}.usableSubnetsGridHeader`;
export const connectionAlertMessage = `${prefix}.connectionAlertMessage`;
export const testLoginLabel = `${prefix}.testLoginLabel`;

export const ENGLISH = {
    [usableSubnetsGridHeader]: 'Usable Subnets ({0})',
    [connectionAlertMessage]: 'Test Login Custom IPAM profile before proceeding to add subnets',
    [testLoginLabel]: 'Test Login',
};
